import { Component, ViewEncapsulation, ViewChild, OnDestroy, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs/Subscription';

import { Registration } from '~auth/model';
import { KeybindDescription, KEYBOARD_CODES, KeybindService } from '~core/services';
import { UserService, ModalService, RegistrationService } from '~auth/services';
import { SignInComponent } from '~auth/components/signin.component';

@Component({
  selector: 'uw-registration',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VerificationComponent implements OnDestroy {
  @ViewChild('registration') content;

  registrationModal: NgbModalRef;
  regCodeForm: FormGroup;
  close = new EventEmitter();
  showError: boolean = false;
  subscriptions: Subscription[] = [];
  progressVisible: boolean;
  inputEmail: string;
  inputPwd: string;

  errorMsg: string = 'You have entered an invalid registration code. Please check your entry.';

  constructor(
    private ngbModal: NgbModal,
    private fb: FormBuilder,
    private keybindService: KeybindService,
    private registrationService: RegistrationService,
    private modalService: ModalService,
    private userService: UserService) {
    this.regCodeForm = this.fb.group({
      regCode: [null, [Validators.required]]
    });
    this.showError = false;

    this.subscriptions.push(this.keybindService.bind(new KeybindDescription(KEYBOARD_CODES.escape))
      .subscribe(x => { this.closeModal(); }));
  }

  submitRegistrationCode() {
    this.progressVisible = true;
    const regCode = this.regCodeForm.get('regCode').value;
    const data: Registration = { registrationCode: regCode, username: this.inputEmail };

    this.registrationService.verifyUser(data)
      .take(1)
      .subscribe((r: any) => {
        if (!r.validated) {
          this.showError = true;
          this.progressVisible = false;
        } else {
          this.proceedLogin();
        }
      }, e => {
        if (e.status !== 409) {
          this.showError = true;
          this.progressVisible = false;
          this.errorMsg = 'Problem in validating registration code. Please contact admin.';
        } else { // User is already validated = 409 code, proceed login
          this.proceedLogin();
        }
      });
  }

  resendCode() {
    this.progressVisible = true;
    this.registrationService.resendValidationCode(this.inputEmail)
      .take(1)
      .subscribe(r => { this.progressVisible = false; },
        e => {
          this.errorMsg = 'Problem in resending code. Please contact admin.';
          this.progressVisible = false;
        });
  }

  open(params: any) {
    this.regCodeForm.reset();
    this.inputEmail = params.email;
    this.inputPwd = params.pwd;
    this.registrationModal = this.ngbModal.open(this.content, {
      keyboard: false,
      backdrop: 'static',
      windowClass: 'registration-modal'
    });
  }

  goBack() {
    this.modalService.getModalComponent(SignInComponent);
    this.closeModal();
  }

  closeModal() {
    this.close.emit('CLOSE');
    this.registrationModal.close();
    this.userService.signOut()
      .take(1)
      .subscribe();
  }

  proceedLogin() {
    this.userService.signIn(this.inputEmail, this.inputPwd)
      .take(1)
      .subscribe(response => {
        this.progressVisible = false;
        this.showError = false;
        this.registrationModal.close();
      }, error => {
        this.showError = true;
        this.progressVisible = false;
      });
  }

  ngOnDestroy() {
    this.close.complete();
    this.subscriptions.forEach(s => s.unsubscribe());
    this.subscriptions = [];
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/auth/components/verification.component.ts